import { render } from "./EtcItemRight.vue?vue&type=template&id=46fa0060&scoped=true"
import script from "./EtcItemRight.vue?vue&type=script&lang=js"
export * from "./EtcItemRight.vue?vue&type=script&lang=js"

import "./EtcItemRight.vue?vue&type=style&index=0&id=46fa0060&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46fa0060"]])

export default __exports__